module.exports = __webpack_public_path__ + "static/poliba.2487cc7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/curriculum/poliba.png
// module id = 910
// module chunks = 25892245095017 57490047887898